import { render } from "./UserNotifications.vue?vue&type=template&id=3a221c9b&scoped=true"
import script from "./UserNotifications.vue?vue&type=script&lang=js"
export * from "./UserNotifications.vue?vue&type=script&lang=js"

import "./UserNotifications.vue?vue&type=style&index=0&id=3a221c9b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a221c9b"]])

export default __exports__